<ds-modal class="modal-container" [modal]="modal" [title]="'create_tasks' | translate">
  <div>
    <div class="row">
      <div class="col-12">
        <h3>{{ 'task_details_label' | translate }}</h3>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-12">
        {{ 'form-field-marked-as-required' | translate }}
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <form [formGroup]="form">
          @if (availableProjects$ | async; as availableProjects) {
            <div class="d-flex gap-2 mb-4">
              <div class="flex-grow-1">
                <ds-input
                  [label]="'available_projects' | translate"
                  required="true"
                  [instructions]="'available_projects_instructions' | translate"
                  [errorMessage]="projectInputError(availableProjects)"
                  [errorState]="formFieldErrors[$task.projectId]?.length > 0"
                >
                  <select
                    class="w-100"
                    ds-input-field
                    data-test-id="project-selector"
                    id="project-selector"
                    [formControlName]="$task.projectId"
                  >
                    <option [ngValue]="null" disabled>{{ projectPlaceholder(availableProjects) }}</option>
                    @for (project of availableProjects; track project[$project._id]) {
                      <option [ngValue]="project">
                        {{ project[$project.name] | ellipsis: 30 }}
                      </option>
                    }
                  </select>
                </ds-input>
                @if ((canPushToIssueTracking$ | async) && !selectedProjectIsGithub) {
                  <div class="row" id="issue-tracking">
                    <div class="col-12">
                      <ds-checkbox
                        [label]="issueIntegrationProjectLabel$ | async"
                        [isSelected]="pushToIssueTracking"
                        (valueChange)="pushToIssueTrackingChange($event)"
                      ></ds-checkbox>
                      @if (
                        isIssueTrackingTypesSelectorVisible() && (issueTrackingIssueTypes$ | async);
                        as issueTrackingIssueTypes
                      ) {
                        <div>
                          <ds-input
                            [label]="'push_task_as' | translate"
                            [required]="isIssueTrackingTypesSelectorVisible()"
                            [errorMessage]="formFieldErrors[$task.issueIntegrationType]"
                            [errorState]="formFieldErrors[$task.issueIntegrationType]?.length > 0"
                            class="mb-4"
                          >
                            <select
                              class="w-100"
                              ds-input-field
                              id="jira-ticket-type-selector"
                              [formControlName]="$task.issueIntegrationType"
                            >
                              <option [ngValue]="null" disabled selected>{{ selectIssueTypeLabel$ | async }}</option>
                              @for (issueTrackingIssueType of issueTrackingIssueTypes; track issueTrackingIssueType.id) {
                                <option [ngValue]="issueTrackingIssueType.id">
                                  {{ issueTrackingIssueType.name | translate }}
                                </option>
                              }
                            </select>
                          </ds-input>
                        </div>
                      } @else {
                        @if (pushToIssueTracking && loadingError$ | async) {
                          <div class="alert alert-danger" role="alert">
                            {{ 'error_loading_jira_project_issue_types' | translate }}
                          </div>
                        }
                      }
                    </div>
                  </div>
                }
              </div>
              <div class="mt-5">
                <button
                  ds-button
                  class="create-project text-nowrap"
                  type="button"
                  (click)="createNewProject()"
                  [variant]="DsButtonVariants.secondary"
                >
                  {{ 'create_project' | translate }}
                </button>
              </div>
            </div>
          }

          @if (projectCreatedSuccessMessage$ | async; as projectCreatedSuccessMessage) {
            <ds-banner
              class="d-block mb-3"
              [state]="DsBannerState.success"
              [showTitle]="false"
              [showAction]="false"
              [showCloseButton]="true"
              (closed)="onCreateProjectSuccessBannerClosed()"
            >
              <div ds-banner-body>
                {{ projectCreatedSuccessMessage }}
              </div>
            </ds-banner>
          }

          <ds-input
            [label]="'label_task_form_status' | translate"
            [required]="false"
            [state]="DsInputStates.inactive"
            class="mb-4"
          >
            <input [id]="$task.status" class="w-100" ds-input-field [formControlName]="$task.status" />
          </ds-input>

          <ds-input [label]="'label_task_priority' | translate" [required]="false" class="mb-4">
            <select [id]="$task.priority" class="w-100" ds-input-field [formControlName]="$task.priority">
              @for (option of taskPriorityOptions; track $index) {
                <option [value]="option.priorityValue">
                  {{ option.name | translate }}
                </option>
              }
            </select>
          </ds-input>
        </form>
      </div>
    </div>
  </div>
  <div *ds-modal-slide-out-footer class="d-flex modal-footer-content">
    <button ds-button type="submit" [variant]="DsButtonVariants.primary" id="submit-btn" class="me-3" (click)="submit()">
      {{ 'create_tasks' | translate }}
    </button>
    <button
      ds-button
      type="button"
      [variant]="DsButtonVariants.secondary"
      id="cancel-task-creation-button"
      (click)="modalService.closeCurrentModal()"
    >
      {{ 'form_cancel' | translate }}
    </button>
  </div>
</ds-modal>
